import is from '@sindresorhus/is';
import { useCallback } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { ANCHOR_SKILL_ID_ATTRIBUTE } from '../../../comments/anchor/grammar';
import type { ProfileForm } from '../types';

// Scrolls the first skill missing a proficiency level into view. Skills expose their id via the
// skill-anchor attribute (see SkillList), which is how we locate the element after a failed save.
export const useScrollToInvalidSkill = (formMethods: UseFormReturn<ProfileForm>): (() => void) => {
    return useCallback(() => {
        const firstInvalidSkill = formMethods
            .getValues('competencies')
            .flatMap((competency) => competency.skills)
            .find((skill) => !is.number(skill.level));

        if (is.undefined(firstInvalidSkill)) {
            return;
        }

        requestAnimationFrame(() => {
            const element = document.querySelector<HTMLElement>(
                `[${ANCHOR_SKILL_ID_ATTRIBUTE}="${CSS.escape(firstInvalidSkill.id)}"]`,
            );
            element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }, [formMethods]);
};
